import { useMutation } from "@tanstack/react-query";
import { generateAgentSalesReport } from "../../services/agentSales";

export const useGenerateAgentSalesReport = () => {
  const mutation = useMutation({
    mutationFn: (reportData) => generateAgentSalesReport(reportData),
  });
  
  return mutation;
};

